export enum ContractedBusinessManageAction {
  CREATE = 'Create',
  DELETE = 'Delete',
  DUPLICATE = 'Duplicate',
  RENAME = 'Rename',
  IMPORT = 'Import',
}
